import React from "react";
import { LoadingButton } from "@mui/lab";
import { Add as IconAdd } from "@mui/icons-material";

function ButtonCreate({ onClick, isLoading, label }) {
  return (
    <LoadingButton
      color="primary"
      type="submit"
      loading={isLoading}
      loadingPosition="start"
      startIcon={<IconAdd />}
      variant="contained"
      onClick={() => {
        onClick && onClick();
      }}
    >
      {label}
    </LoadingButton>
  );
}

ButtonCreate.defaultProps = {
  onClick: () => {},
  isLoading: false,
  label: "Create",
};

export default ButtonCreate;
